export default "__VITE_ASSET__BZ6oNhIG__"